  $(document).ready(function() {
          $("select#FilterTags").change(function() {
              let selectedItem = $(this).children("option:selected").val();
              //alert("You have selected the name - " + selectedItem);
              window.location.href = selectedItem;
            });


            // $('.template-product').find('.static-content').text('/ YARD DELIVERED');
    
            $('.mini-cart').find('.price').remove('USD');
    
        });